import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "me-2" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "settings-card profile-banner-card" }
const _hoisted_4 = { class: "profile-banner-strip" }
const _hoisted_5 = { class: "profile-avatar-tile" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "profile-banner-info" }
const _hoisted_8 = { class: "profile-banner-name" }
const _hoisted_9 = { class: "profile-banner-email" }
const _hoisted_10 = { class: "container-fluid py-4" }
const _hoisted_11 = { class: "row g-3" }
const _hoisted_12 = { class: "col-12 col-xl-6" }
const _hoisted_13 = { class: "settings-card h-100" }
const _hoisted_14 = { class: "settings-card__header" }
const _hoisted_15 = { class: "settings-card__title" }
const _hoisted_16 = { class: "settings-card__body" }
const _hoisted_17 = { class: "profile-info-list" }
const _hoisted_18 = { class: "profile-info-row" }
const _hoisted_19 = { class: "profile-info-text" }
const _hoisted_20 = { class: "settings-field-label" }
const _hoisted_21 = { class: "profile-info-value" }
const _hoisted_22 = { class: "profile-info-row" }
const _hoisted_23 = { class: "profile-info-text" }
const _hoisted_24 = { class: "settings-field-label" }
const _hoisted_25 = { class: "profile-info-value" }
const _hoisted_26 = { class: "profile-info-row" }
const _hoisted_27 = { class: "profile-info-text" }
const _hoisted_28 = { class: "settings-field-label" }
const _hoisted_29 = { class: "profile-info-value" }
const _hoisted_30 = { class: "col-12 col-xl-6" }
const _hoisted_31 = { class: "settings-card h-100" }
const _hoisted_32 = { class: "settings-card__header" }
const _hoisted_33 = { class: "settings-card__title" }
const _hoisted_34 = { class: "settings-card__body" }
const _hoisted_35 = { class: "settings-field-label profile-roles-label" }
const _hoisted_36 = { class: "profile-roles-list" }
const _hoisted_37 = {
  key: 0,
  class: "profile-role-row"
}
const _hoisted_38 = { class: "profile-role-name" }

import User from '@/models/User'
import AuthService from '@/services/AuthService'
import {onBeforeMount, ref, Ref} from 'vue'
import {useStorage} from '@/services/stores/Storage'
import {storeToRefs} from 'pinia'


export default /*@__PURE__*/_defineComponent({
  __name: 'Profile',
  setup(__props) {

const user: Ref<User> = ref(new User())
const storage = useStorage()
const {logoUrl} = storeToRefs(storage)

onBeforeMount(() => {
  user.value = AuthService.getCurrentUser()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "profile-banner-gradient" }, null, -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: _unref(logoUrl),
              alt: "profile_image",
              class: "profile-avatar-img"
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h5", _hoisted_8, _toDisplayString(user.value.name), 1),
            _createElementVNode("p", _hoisted_9, _toDisplayString(user.value.email), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "settings-icon-chip settings-icon-chip--info" }, [
                _createElementVNode("em", { class: "fas fa-id-card" })
              ], -1)),
              _createElementVNode("h6", _hoisted_15, _toDisplayString(_ctx.$t('users.profile')), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _cache[2] || (_cache[2] = _createElementVNode("em", { class: "fas fa-user profile-info-icon" }, null, -1)),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('users.fields.name')), 1),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(user.value.name), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _cache[3] || (_cache[3] = _createElementVNode("em", { class: "fas fa-envelope profile-info-icon" }, null, -1)),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('users.fields.email')), 1),
                    _createElementVNode("span", _hoisted_25, _toDisplayString(user.value.email), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _cache[4] || (_cache[4] = _createElementVNode("em", { class: "fas fa-phone profile-info-icon" }, null, -1)),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t('users.fields.phone')), 1),
                    _createElementVNode("span", _hoisted_29, _toDisplayString(user.value.phone), 1)
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "settings-icon-chip settings-icon-chip--orange" }, [
                _createElementVNode("em", { class: "fas fa-gear" })
              ], -1)),
              _createElementVNode("h6", _hoisted_33, _toDisplayString(_ctx.$t('users.platform_settings')), 1)
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('users.fields.roles')), 1),
              _createElementVNode("ul", _hoisted_36, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.value.roles, (value, role) => {
                  return (_openBlock(), _createElementBlock("li", { key: role }, [
                    value
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "settings-icon-chip settings-icon-chip--primary profile-role-chip" }, [
                            _createElementVNode("em", { class: "fas fa-user-shield" })
                          ], -1)),
                          _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t('users.fields.' + role)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})